export default "__VITE_ASSET__CGisWxrp__"